import api from '../utils/api';
// import { toast } from 'react-toastify';

export const verifyVoucherPassCode=(data, callback)=>{
    const form = new FormData();
    form.append('voucher_id', data.voucher_id);
    form.append("passcode", data.passcode)
    api
    .post(`/voucher/verify-passcode`, form)
    .then((response) => callback(response))
    .catch(error => {
        console.log("Oops! Something went wrong.", error);
        // toast.error(error.response.data.message,{position:toast.POSITION.TOP_RIGHT})
    });  
}

// export const axios_getTaxInfo=(callback)=>{
//     axios
//     .get(`/tax-info/getTaxInfo`, {
//         headers: {
//             'Content-Type': 'application/json'
//         }
//     },
    
//     )
//     .then((response) => callback(response))
//     .catch(error => {
//         console.log("Oops! Something went wrong.", error);
//         // toast.error(error.response.data.message,{position:toast.POSITION.TOP_RIGHT})
//     });  
// }